<div class="travel-itinerary" [class.no-shadow]="noShadow" [class.upsell]="showUpsell || isFlightBySector" *ngIf="validationVm as validator">
  <div class="itinerary-header" (click)="showFlightDetail.emit({ validator: validator, sectorNumber: defaultSectorNumber() })">
    <div class="body-header-itineray">
      <strong>{{headerTitle | transloco}}</strong>
      <ng-container *ngFor="let sector of validator.TripOption.Sectors; let first = first; let last = last">
        <span class="date">
          <ng-container *ngIf="isOneWay(first, last); else roundTrip">
            {{sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | titlecase}}
          </ng-container>
          <ng-template #roundTrip>
            <ng-container *ngIf="first">
              {{sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | titlecase}} -
            </ng-container>
            <ng-container *ngIf="last">
              {{sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | titlecase}}
            </ng-container>
          </ng-template>
        </span>
      </ng-container>
    </div>
    <i aria-hidden="true" class="icon-expand"></i>
  </div>
  <div class="itinerary-body">
    <ng-container *ngFor="let sector of validator.TripOption.Sectors">
      <app-simple-travel-summary
        [options]="[sector]"
        [summaryProvider]="summaryProvider"
        [type]="sector.SectorNumber"
        [isInternational]="isInternational"
        (showDetailEvent)="showFlightDetail.emit({ validator: validator, sectorNumber: defaultSectorNumber(sector.SectorNumber) })">
      </app-simple-travel-summary>
    </ng-container>
    <app-travel-segment-upsell
      [isFlightBySector]="isFlightBySector"
      [isMobile]="isMobile"
      [baggage]="baggage"
      [fareFamilies]="fareFamilies"
      [upsellLoading]="upsellLoading"
      [upsellSelected]="upsellSelected"
      [noShadow]="isPackageBookingResume"
      [showUpsell]="showUpsell"
      (openUpsell)="openUpsell.emit()">
    </app-travel-segment-upsell>
  </div>
</div>